import { render } from "./rightBar2.vue?vue&type=template&id=5a8d545f"
import script from "./rightBar2.vue?vue&type=script&lang=js"
export * from "./rightBar2.vue?vue&type=script&lang=js"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__